import { render, staticRenderFns } from "./SentenceEditPopover.vue?vue&type=template&id=78cac4e1&"
import script from "./SentenceEditPopover.vue?vue&type=script&lang=js&"
export * from "./SentenceEditPopover.vue?vue&type=script&lang=js&"
import style0 from "./SentenceEditPopover.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports